import React from 'react';
import clsx from 'clsx';
import { normalizeStatus } from './workOrderMeta';

/**
 * Linear-style status glyph for a work order: the circle fills as the work
 * moves from requested to done. Pending, in progress and completed match
 * the violation glyphs, so the two lists read alike.
 */
export const WorkOrderStatusIcon: React.FC<{
  status: string;
  className?: string;
}> = ({ status, className }) => {
  const common = clsx('h-3.5 w-3.5 shrink-0', className);
  const ring = (
    <circle cx="7" cy="7" r="5.5" fill="none" stroke="currentColor" strokeWidth="1.5" />
  );
  switch (normalizeStatus(status)) {
    case 'Pending':
      return (
        <svg viewBox="0 0 14 14" className={clsx(common, 'text-zinc-400')} aria-hidden>
          <circle cx="7" cy="7" r="5.5" fill="none" stroke="currentColor" strokeWidth="1.5" strokeDasharray="2 2" />
        </svg>
      );
    case 'Approved':
      return (
        <svg viewBox="0 0 14 14" className={clsx(common, 'text-cyan-400')} aria-hidden>
          {ring}
        </svg>
      );
    case 'Scheduled':
      return (
        <svg viewBox="0 0 14 14" className={clsx(common, 'text-violet-400')} aria-hidden>
          {ring}
          <path d="M7 3.5 A3.5 3.5 0 0 1 10.5 7 L7 7 Z" fill="currentColor" />
        </svg>
      );
    case 'InProgress':
      return (
        <svg viewBox="0 0 14 14" className={clsx(common, 'text-amber-400')} aria-hidden>
          {ring}
          <path d="M7 3.5 A3.5 3.5 0 0 1 7 10.5 Z" fill="currentColor" />
        </svg>
      );
    case 'Completed':
      return (
        <svg viewBox="0 0 14 14" className={clsx(common, 'text-sky-400')} aria-hidden>
          <circle cx="7" cy="7" r="6" fill="currentColor" />
          <path d="M4.5 7.2 6.3 9l3.2-3.6" fill="none" stroke="#08090A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'Cancelled':
      return (
        <svg viewBox="0 0 14 14" className={clsx(common, 'text-zinc-500')} aria-hidden>
          <circle cx="7" cy="7" r="6" fill="currentColor" />
          <path d="M5 5l4 4M9 5l-4 4" stroke="#08090A" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      );
    default:
      return (
        <svg viewBox="0 0 14 14" className={clsx(common, 'text-zinc-500')} aria-hidden>
          {ring}
        </svg>
      );
  }
};

export default WorkOrderStatusIcon;
